import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {EmployeePhonListReportData} from "./employee-phon-list-report.data";

@Injectable()
export class EmployeePhonListReportModel extends ReportModel<EmployeePhonListReportData> {
    constructor(injector: Injector) {
        super(injector, EmployeePhonListReportData);
    }
}
